import { Modal, useModals } from 'almanac-ui/Modal'
import { Menu } from 'components/Menu/Menu'
import { useProperties } from 'hooks/useProperties'
import { useState } from 'react'
import { Item } from '@react-stately/collections'
import { Pressable } from '@react-aria/interactions'
import Styles from './SelectDatePropertyModal.module.scss'
import { ChevronDown } from 'almanac-ui/icons/12'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'

interface Props {
  onConfirm: (propertyId: number) => void
}

export const SelectDatePropertyModal = ({ onConfirm }: Props) => {
  const { closeModal } = useModals()
  const { dateProperties } = useProperties()
  const [propertyId, setPropertyId] = useState<number>(dateProperties[0].id)

  const handleConfirm = () => {
    onConfirm(propertyId)
    closeModal()
  }

  return (
    <Modal.Root>
      <Modal.Header
        headingLevel={3}
        title="There are multiple date properties in this project, select one to view the calendar by"
      />
      <Modal.Content>
        <div className={Styles.label}>Set up calendar by</div>
        <MenuTrigger placement="bottom" popoverClassName={Styles.popover}>
          <Pressable>
            <div className={Styles.select}>
              {dateProperties.find((p) => p.id === Number(propertyId))?.name || 'Select Property'} <ChevronDown />
            </div>
          </Pressable>
          <Menu
            selectionMode="single"
            selectedKeys={new Set([propertyId.toString()])}
            onAction={(id) => setPropertyId(id as number)}
          >
            {dateProperties.map((property) => (
              <Item key={property.id} textValue={property.name}>
                {property.name}
              </Item>
            ))}
          </Menu>
        </MenuTrigger>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={handleConfirm} size="lg">
            Done
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
